let _ = require('../_.js');


var $ = jQuery;

// -------------- TEMPLATING ENGINE ------------------

// Summary:
// If a element has class TEMPLATE, it becomes a template for reusable components on its parent.
// calling $(selector).component(id) will create a new element or return an existing element with that id from template.
// calling $component.show_only_this(speed = 0) will hide all other sibling components.


let start_timestamp = Math.floor(Date.now() / 1000);

_.ac_templates_init = function () {

    // Should happen before everything else:
    // Remove all placeholder data from elements and reset the elements
    $(".PLACEHOLDER").empty().removeClass('PLACEHOLDER');

    // $.component(id).  Creates a new child component from associated
    // template and assigns passed id, or returns existing component if it has
    // already been created.  If the containmer class has class HIGHLIGHT-NEW then adding
    // the component makes it pop when a new item added.
    jQuery.fn.component = function (id, template_id = 'default', options = {}) {

        id = String(id).replace(/[^a-zA-Z0-9]/g, "_");

        let $parent = $(this);
        let $parents_parent = $(this);

        let defaults = {
            speed: 0,            // fade in effct speed
            highlight: null,       // If set to true or false, configures highlight on new effect.  Otherwise looks for class "HIGHLIGHT-NEW" on parent
            highlight_speed: 2500, // duration to show highlighted new items
            direction: "append",   // append, prepend, asc, or desc.  append/prepend add to begining or end
            attach: true,          // true / false for attach the new element to the parent
            $after: null,          // provide an element to look for - the inserted object will be after this element among its peers
            sort_id: null,          // A custom sorting value, if not set we will use id.  Only uses id on create, retains existing sort id on update.
            show_effect: null          // A custom sorting value, if not set we will use id.  Only uses id on create, retains existing sort id on update.
        };

        options = Object.assign({}, defaults, options);

        // Parse template immediatly if it hasn't been parsed yet
        if ($parent.children().length == 1 && $parent.children().eq(0).hasClass('TEMPLATE')) {
            _.ac_templates_parse_template($parent.children().eq(0));
        }

        // Require class HIGHLIGHT-NEW for highlight feature.
        if (options.highlight === null) {
            options.highlight = $(this).hasClass("HIGHLIGHT-NEW");
        }

        // Do not use fadeIn effects for first 5 seconds.
        if (Math.floor(Date.now() / 1000) - start_timestamp <= 5) {
            options.speed = 0;
        }

        let $children = $parent.children();

        // Avoid messing with THEAD and TBODY when storing / retrieving template data
        if ($parent.prop("tagName") === 'TBODY' || $parent.prop("tagName") === 'THEAD') {
            $parents_parent = $parent.parent();
        }

        // template_id localized version of us saying cid- before something
        let cid_prefix = 'cid';
        if (template_id != 'default') {
            cid_prefix = 'cid_' + template_id;
        }

        let template = $parents_parent.data('template-' + template_id);
        let sort_id = options.sort_id;
        let $after = options.$after;

        // Find the child, if it exists
        let $child = $parent.children('.' + cid_prefix + '-' + id);

        // Is it in the right group?  If not, remove it.
        if ($child.length && $after) {
            if ($child.data('template-grouping') != template_id + "-" + $after.cid()) {
                $child.remove();
                // Prevent the new element from animating
                options.highlight = false;
                options.speed = 0;
                // Set $child to a empty selector
                $child = $('.nonexistent-class');
                // refresh children
                $children = $parent.children();
            }
        }

        // Does it have the right sort id?  If not, remove it.
        if ($child.length && sort_id !== null && $child.attr('data-cid-sort') != sort_id) {
            $child.remove();
            // Prevent the new element from animating
            options.highlight = false;
            options.speed = 0;
            // Set $child to a empty selector
            $child = $('.nonexistent-class');
            // refresh children
            $children = $parent.children();
        }

        // If child does not exist...
        if (!$child.length) {

            // Create it
            $child = $(template);

            // If no sort id was provided, we use id as sort id.
            if (sort_id === null) {
                sort_id = id;
            }

            // Add appropriate identifiers to the new element
            $child.addClass(cid_prefix + '-' + id)
                .attr('data-cid', id)
                .attr('data-cid-sort', sort_id)

            if ($after) {
                // console.log($after);
                $child.data('template-grouping', template_id + "-" + $after.cid());
            }

            // // For targeting CSS rules
            // if (template_id != 'default') {
            //     $child.addClass("template-" + template_id);
            // }

            // Immediatly parse any templates in the dom.
            let $subtemplates = $child.find('.TEMPLATE');
            while ($subtemplates.length) {
                _.ac_templates_parse_template($subtemplates.first());
                $subtemplates = $child.find('.TEMPLATE');
            }

            // Just return the element if we aren't attaching it.
            if (!options.attach) {
                return $child;
            }

            // We decide where to put the elemenet here.

            // attach: true,        // can be a jquery selector element, 'self', or none.
            // direction: "append",   // append, prepend, asc, or desc.  append/prepend add to begining or end
            // after: null            // provide an element to look for - the inserted object will be after this element among its peers

            // the sort_id we are using to determine where to put things if direction is asc or desc

            // The element we are intending to insert into a group after, could be null.


            // The resolved target after element.  If null, we prepend to the parent.
            let $after_target = null;

            // All of the peer elements in the grouping of elements we are considering for sort order.
            let aFamily = [];

            // Handle case where $after is provided.
            if ($after) {
                // $after.fadeIn(); // for debug
                // Find all siblings of $after with the same data-template-grouping.
                let template_grouping_search = template_id + "-" + $after.cid();
                $children.each(function () {
                    // Would be nice to do this more generally and not rely on template_id for match
                    // let match = $(this).data('template-grouping') && $(this).data('template-grouping').get(1) === $after.get(1);
                    let match = $(this).data('template-grouping') && $(this).data('template-grouping') == template_grouping_search;
                    if (match) aFamily.push($(this));
                });
            } else {
                $children.each(function () {
                    // Find all elements which are of the same template, we will use this for sorting
                    let match = ($(this).attr('data-template_id') && $(this).attr('data-template_id') == template_id) || (!$(this).attr('data-template_id') && template_id == 'default');
                    if (match) aFamily.push($(this));
                });
            }

            // if (id == 203) {
            //     console.warn($children);
            //     console.log(aFamily);
            // }

            if (aFamily.length) {
                // Handle different cases of direction.
                switch (options.direction) {
                    case 'asc':
                    case 'desc':
                        let insertIndex = -1;
                        let group_min_id = null;
                        let group_max_id = null;
                        let direction = options.direction;

                        // Look for the index at which the element should be inserted.
                        for (let i in aFamily) {
                            let el = aFamily[i];
                            // console.log($(el).attr('data-cid-sort'));
                            let sibling_sort_id = parseInt($(el).attr('data-cid-sort'));

                            // Find bounds
                            if (group_min_id === null || group_min_id > sibling_sort_id) {
                                group_min_id = sibling_sort_id;
                            }

                            if (group_max_id === null || group_max_id < sibling_sort_id) {
                                group_max_id = sibling_sort_id;
                            }

                            if ((direction === 'asc' && sort_id > sibling_sort_id) ||
                                (direction === 'desc' && sort_id < sibling_sort_id)) {
                                insertIndex = i;
                            }
                        }

                        // console.log("group bound min id", group_min_id)
                        // console.log("group bound max id", group_min_id)
                        // console.log("group bound search id", sort_id)

                        if (insertIndex === -1) {
                            if (direction === 'asc') {
                                if (sort_id > group_max_id) {
                                    $after_target = aFamily.last();
                                    // console.warn("1", template_id);
                                } else { //} if (sort_id < group_min_id) {
                                    $after_target = null;
                                    // console.warn("2", template_id);
                                    // } else {
                                    // _.shouldnt_happen();
                                }
                            } else {
                                if (sort_id < group_max_id) {
                                    $after_target = aFamily.last();
                                } else { // if (sort_id > group_min_id) {
                                    $after_target = null;
                                    // } else {
                                    // _.shouldnt_happen();
                                }
                            }
                        } else {
                            $after_target = aFamily[insertIndex];
                        }
                        break;
                    case 'prepend':
                        $after_target = $after;
                        break;
                    case 'append':
                    default:
                        $after_target = aFamily.length ? aFamily[aFamily.length - 1] : $after;
                        break;
                }
            }

            if ($after_target == null && $after) {
                $after_target = $after;
            }

            // If we weren't provied a specific target element, and are just inserting into the parent, 
            // the target we found may have elements after it which are grouped to it.  We should insert after these elements.
            if (!$after && $after_target) {
                aFamily = $children.filter(function () {
                    return $(this).data('template-grouping') && $(this).data('template-grouping').get(1) === $after_target.get(1);
                });
                if (aFamily.length) {
                    $after_target = aFamily.last();
                }
            }

            // Do this insert with animations?
            if (options.speed) {

                // Make sure its invisible
                $child.hide();

                // Insert $child into the DOM at the appropriate location.
                if ($after_target) {
                    $after_target.after($child);
                } else {
                    $parent.prepend($child);
                }

                // Make sure its really really invisible
                $child.hide();

                if (options.highlight) {
                    $child.addClass("element-added");
                }

                // Animate
                if (options.show_effect) {
                    $child.show("slide", { direction: options.show_effect }, options.speed);
                } else {
                    $child.fadeIn(options.speed, function () {
                        if (options.highlight) {
                            $child.css({ 'transition': 'all 0.5s ease-in-out' });
                            setTimeout(function () {
                                $child.removeClass("element-added");
                                setTimeout(function () {
                                    $child.css({
                                        'transition': ''
                                    });
                                }, 1000)
                            }, options.highlight_speed);
                        }
                    });
                }


            } else {

                // No animations.
                // Insert $child into the DOM at the appropriate location.

                if ($after_target) {
                    $after_target.after($child);
                } else {
                    $parent.prepend($child);
                }
            }

            _._ui_resize_immediate();
        }

        return $child;
    };

    // Alias for prepending a component to a list rather than appending it
    jQuery.fn.component_prepend = function (id, speed = 600, highlight = null, direction = "prepend") {
        id = iString(id).replace(/[^a-zA-Z0-9]/g, "_");
        return $(this).component.bind(this)(id, speed, highlight, direction);
    }

    // Removes components which are no longer associated to data. If the containmer class has class 
    // HIGHLIGHT-NEW then removing components makes it pop when an item is removed..
    jQuery.fn.remove_unlisted_components = function (ids, template_id = 'default', speed = 600, highlight = null, show_effect = null) {
        // Require class HIGHLIGHT-NEW for highlight feature.

        if (highlight === null) {
            highlight = $(this).hasClass("HIGHLIGHT-NEW");
        }

        // Convert ids to string for comparison
        ids = ids.map(function (id) {
            return String(id).replace(/[^a-zA-Z0-9]/g, "_");
        });

        const $children = $(this).children();

        $children.each(function () {
            const $child = $(this);
            const cid = $child.attr('data-cid');

            if (cid && !ids.includes(cid) && (template_id == 'default' || $child.attr('data-template_id') == template_id)) {

                if (speed) {
                    if (highlight) {
                        $child.addClass("element-deleted");
                    }
                    if (show_effect) {
                        $child.hide("slide", { direction: show_effect }, speed);
                        setTimeout(function () {
                            $child.remove();
                        }, speed);
                    } else {
                        $child.fadeOut(speed, function () {
                            $child.remove();
                        });

                    }
                } else {
                    $child.remove();
                }
            }
        });
    };

    // Returns a component records id
    jQuery.fn.cid = function () {
        return $(this).data('cid');
    };

    // Given a target element, it hides all other siblings except for this element.
    // This element gets shown.  If speed provided, uses fadeOut/fadeIn to animate.
    // It can call a callback on completion.
    $.fn.show_only_this = function (speed = 0, callback = $.noop, agressivly_stop_animations = false) {

        if (Math.floor(Date.now() / 1000) - start_timestamp <= 4) {
            speed = 0;
        }

        // Save the current object
        var $this = this;

        // Find all the siblings
        var $siblings = $this.siblings();

        // Check if the element is the only one visible
        if ($this.is(":visible") && $siblings.filter(":visible").length === 0) {
            // If yes, invoke the callback immediately
            callback();
        } else {
            var $visibleSiblings = $siblings.filter(":visible");

            if (speed) {
                if ($this.is(":visible")) $this.hide();

                if ($visibleSiblings.length === 1) {
                    $visibleSiblings.oFadeOut(speed, function () {
                        $visibleSiblings.oHide();
                        if (agressivly_stop_animations) _.finishAllAnimations();
                        $this.fadeIn(speed, function () {
                            callback();
                            if (agressivly_stop_animations) _.finishAllAnimations();
                        });
                    });
                } else {
                    $siblings.oHide();
                    if (agressivly_stop_animations) _.finishAllAnimations();
                    $this.fadeIn(speed, function () {
                        callback();
                        if (agressivly_stop_animations) _.finishAllAnimations();
                    })
                }
            } else {
                $siblings.hide();
                if (agressivly_stop_animations) _.finishAllAnimations();

                if (!$this.is(":visible")) $this.show();
                callback();
                if (agressivly_stop_animations) _.finishAllAnimations();
            }
        }

        // Return the original selector for chaining
        return $this;
    };

    // Reads a 'TEMPLATE' div element and stores it on the parent component.
    _.ac_templates_parse_template = function ($template) {
        let template_id = $template.attr('data-template_id');
        if (!template_id) {
            template_id = 'default';
        }

        // Remove TEMPLATE class
        $template.removeClass("TEMPLATE");

        // Remove 'initialized' classes
        var classes = $template.attr('class').split(' ');
        $.each(classes, function (index, className) {
            if (className.indexOf('_init_') === 0) {
                $template.removeClass(className);
            }
        });

        // Get HTML
        var $parent = $template.parent();

        // Avoid messing with THEAD and TBODY
        if ($parent.prop("tagName") === 'TBODY' || $parent.prop("tagName") === 'THEAD') {
            $parent = $parent.parent();
        }

        $parent.data("template-" + template_id, $template.prop("outerHTML"));

        // Remove from DOM
        $template.remove();

        // Create TEST element if requested
        if ($parent.hasClass("TEMPLATE-TEST")) {
            $parent.component("TEST", template_id).addClass("TEST");
        }
    }

    // Initializes the component template feature.
    //  
    // Child elements of type TEMPLATE are registered as dynamically
    // creatable templates on the parent through use of $(parent).component().
    // If parent element has TEMPLATE-TEST then a test element will be created on page load.
    _.on_ui_update_once(".TEMPLATE", function () {
        _.ac_templates_parse_template.bind(this)($(this));
    }, true);
}